export const ROWS_PER_TABLE_PAGE = 100

export const DEFAULT_COLUMN_SETTINGS = {
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  hideable: false,
  resizable: false,
}

export const MOCK_EMAIL_ADDRESSES = [
  'Jamaal79@yahoo.com',
  'Isaias.Watsica71@gmail.com',
  'Carlee_Von17@hotmail.com',
  'Linnie49@yahoo.com',
  'Christopher50@hotmail.com',
  'Keeley.Tillman12@gmail.com',
]

export const MOCK_PHONE_NUMBERS = [
  '+1 (333) 781-8014',
  '+1 (886) 590-6302',
  '+1 (292) 264-7453',
  '+1 (999) 415-2411',
  '+1 (319) 827-1477',
  '+1 (119) 181-2147',
]
